var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.alert.active)?_c('v-alert',{attrs:{"dense":"","border":"left","type":_vm.alert.type}},[_vm._v(" "+_vm._s(_vm.alert.message)+" ")]):_vm._e(),(_vm.userType() == 'Ops')?_c('Ops',{on:{"alertEvent":_vm.alertEvent}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }